import { useEffect, useRef } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { selectShouldPlaySecondAudio, selectShouldPlaySound } from "../redux/mcqSlice"
import { selectBadgeDetails } from "../redux/badgeSlice"

const LongAudioProvider = () => {

    const { pathname } = useLocation()

    const audioRef = useRef(null)
    const isPlayingRef = useRef(false)
    const entryAudioRef = useRef(null)
    const preloadAudioTagRef = useRef(null)

    const badgeDetails = useSelector(selectBadgeDetails)
    const shouldPlaySound = useSelector(selectShouldPlaySound)
    const shouldPlaySecondAudio = useSelector(selectShouldPlaySecondAudio)

    const showInitialExpertCard = badgeDetails?.showInitialExpertCard
    const isIphone = /iPhone/.test(navigator.userAgent) && !window.MSStream

    useEffect(() => {
        const preloadTag = document.createElement("audio")
        preloadTag.src = "/audio/intro-audio.mp3"
        preloadTag.preload = "auto"
        preloadTag.style.display = "none"
        document.body.appendChild(preloadTag)
        preloadAudioTagRef.current = preloadTag

        return () => {
            if (preloadAudioTagRef.current) {
                document.body.removeChild(preloadAudioTagRef.current)
            }
        }
    }, [])

    useEffect(() => {
        
        if (!audioRef.current) {
            audioRef.current = new Audio("/audio/main-quiz-audio.mp3")
            audioRef.current.loop = true
            audioRef.current.volume = 0
        }
        
        if (!entryAudioRef.current) {
            entryAudioRef.current = new Audio("/audio/intro-audio.mp3")
            entryAudioRef.current.loop = false
        }

        const path = pathname
        const match = path.match(/^\/mcq\/(\d+)$/)
        const questionId = match ? parseInt(match[1], 10) : null
        const isMcqRoute = questionId && questionId >= 1 && questionId <= 10
        const isOnboardingPath = path === "/onboarding"

        if (isOnboardingPath && !isIphone) {
            entryAudioRef.current.volume = 0
            entryAudioRef.current.play().then(() => {
                entryAudioRef.current.pause()
                entryAudioRef.current.currentTime = 0
                entryAudioRef.current.volume = 1
            }).catch(console.error)
        }

        if (questionId === 1 && !shouldPlaySecondAudio && shouldPlaySound) {
            entryAudioRef.current.currentTime = 0
            entryAudioRef.current.volume = 1
            entryAudioRef.current.play().catch(console.error)
        }
        
        if (isOnboardingPath && shouldPlaySound && !isIphone) {
            if (!isPlayingRef.current) {
                audioRef.current.volume = 0
                audioRef.current.play().then(() => {
                    isPlayingRef.current = true
                }).catch(console.error)
            }else{
                audioRef.current.volume = 0
            }
        }

        if (isMcqRoute) {
            if (shouldPlaySound && !showInitialExpertCard) {
                if (!isPlayingRef.current) {
                    audioRef.current.volume = 1
                    audioRef.current.play().then(() => {
                        isPlayingRef.current = true
                    }).catch(console.error)
                } else {
                    audioRef.current.volume = 1
                }
            } else {
                if (isPlayingRef.current) {
                    audioRef.current.pause()
                    isPlayingRef.current = false
                }
            }
        }

        if (!isMcqRoute && !isOnboardingPath) {
            if (audioRef.current && isPlayingRef.current) {
                audioRef.current.pause()
                audioRef.current.currentTime = 0
                audioRef.current.volume = 0
                isPlayingRef.current = false
            }
        }

        if(isIphone && isOnboardingPath){
            if(audioRef.current && isPlayingRef.current){
                audioRef.current.pause()
                audioRef.current.currentTime = 0
                audioRef.current.volume = 0
                isPlayingRef.current = false
            }
        }

        if(shouldPlaySecondAudio && entryAudioRef.current){
            entryAudioRef.current.pause()
            entryAudioRef.current.volume = 0
        }
        
    }, [isIphone, pathname, shouldPlaySecondAudio, shouldPlaySound, showInitialExpertCard])


    
    return null
}

export default LongAudioProvider
